import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mute",
  "use": "icon-mute-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-mute\"><path class=\"st0\" d=\"M8.9 9.1L13 5v15l-3.8-3.8H4V9.1h4.9zm10.9 12.5l-1.6-1.2c3.7-5.2 3.8-10.1 0-14.8l1.6-1.2c4.3 5.4 4.3 11.2 0 17.2zm-3-2l-1.7-1.1c2.4-3.7 2.4-7.3 0-10.9l1.7-1.1c2.9 4.2 2.9 8.7 0 13.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol